import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import BgTitle from "components/title/BgTitle";
import { useTranslation } from "react-i18next";

import kesImg from "images/GroupCompany/kes.png";
import asiImg from "images/GroupCompany/asi.png";
import glamImg from "images/GroupCompany/glam.png";
import GroupCompanyMobileView from "./GroupCompanyMobileView";

const images = [asiImg, glamImg, kesImg];

const Container = tw.div`relative py-16`;
const Content = tw.div`max-w-screen-xl mx-auto`;

const GridContainer = styled.div`
  ${tw`grid gap-6 mt-4`};
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 768px) {
    grid-template-columns: repeat(
      3,
      1fr
    ); /* Show 3 cards per row on medium+ screens */
  }
`;

const Card = styled.div`
  ${tw`flex flex-col justify-between h-full bg-gray-100 shadow-md rounded-lg overflow-hidden`};
  border: 1px solid #e2e8f0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    ${tw`shadow-lg`}
    transform: translateY(-5px);
  }
`;

const CardImageContainer = styled.div`
  ${tw`w-full h-40 bg-white flex items-center justify-center`};
`;

const CardImage = styled.img`
  ${tw`max-w-[66%] max-h-full object-contain`};
`;

const TextInfo = tw.div`p-4 flex-grow flex flex-col justify-between`;
const TitleReviewContainer = tw.div`mb-4`;
const Title = tw.h5`text-base font-bold text-ncc`;
const Subtitle = tw.h6`text-sm text-gray-600 mt-1`;

const SecondaryInfoContainer = tw.div`flex items-center mt-2`;
const IconWithText = tw.div`flex items-center text-gray-700`;

const Text = tw.div`ml-2 text-sm font-medium`;

const PrimaryButton = styled(PrimaryButtonBase)`
  ${tw`sm:text-sm mt-4 w-full rounded py-2 bg-ncc text-white hover:bg-blue-700`};
  transition: background-color 0.3s ease;
`;

export default ({ isXs = false }) => {
  if (isXs) return <GroupCompanyMobileView />;
  const { t } = useTranslation();
  const cards = t("group_company_items", { returnObjects: true });

  return (
    <Container>
      <Content>
        <BgTitle text={t("group_company_headline")} />
        <GridContainer>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImageContainer>
                <CardImage src={images[index]} alt={card.title} />
              </CardImageContainer>
              <TextInfo>
                <TitleReviewContainer>
                  <Title>{card.title}</Title>
                  <Subtitle>{card.subtitle}</Subtitle>
                </TitleReviewContainer>
                <SecondaryInfoContainer>
                  <IconWithText>
                    <PhoneForwardedIcon />
                    <Text>{card.phone}</Text>
                  </IconWithText>
                </SecondaryInfoContainer>
                <PrimaryButton onClick={() => window.open(card.link)}>
                  <i
                    className="fa-solid fa-globe"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                </PrimaryButton>
              </TextInfo>
            </Card>
          ))}
        </GridContainer>
      </Content>
    </Container>
  );
};
